import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const DonorsActions = importer('Stores/Donors/Actions')
const { getDonors } = importer('APIs/donors', null)

export default function * main ({ id }) {
  try {
    yield put(DonorsActions.registerGetDonorProfileLoading())
    const res = yield getDonors(id)
    yield put(DonorsActions.registerGetDonorProfileSuccess(res))
  } catch (error) {
    yield put(DonorsActions.registerGetDonorProfileFailure(error))
  }
}
